import { useCallback } from 'react';
import { setCookie } from '@core/js/utils/cookie.util';
import {
    useFetchBalance,
    useFetchUserDetails,
    useGetUserUrlTemplates,
    useGetPaymentsConfiguration
} from '@core/js/hooks/user';
import { useVerifyJumio } from '@core/js/hooks/auth/hooks/useAfterLoginAction';

export { useVerifyJumio };

export const COOKIE_NAME = 'clientType';

export const useAfterLoginAction = () => {
    const verifyJumio = useVerifyJumio();
    const getUrlTemplates = useGetUserUrlTemplates();
    const fetchUserDetails = useFetchUserDetails();
    const getPaymentsConfiguration = useGetPaymentsConfiguration();
    const fetchBalance = useFetchBalance();

    return useCallback(() => Promise.all([
        fetchUserDetails().then((userDetails) => {
            setCookie(COOKIE_NAME, userDetails.clientType);
            verifyJumio(userDetails);
        }),
        getUrlTemplates(),
        getPaymentsConfiguration(),
        fetchBalance()
    ]), [
        fetchUserDetails,
        verifyJumio,
        getUrlTemplates,
        fetchBalance,
        getPaymentsConfiguration
    ]);
};
